"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_utils_1 = require("@/components/common/button/button.utils");
const result_styles_1 = require("@/components/common/result/result.styles");
require("@/components/common/avatar");
require("@/components/common/button/button");
require("@/components/common/button/button-group");
require("@/components/common/text/semantics/status-message");
let Result = class Result extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
        this.role = 'status';
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderAvatar()}
      <mm-status-message heading=${this.heading} message=${this.description}></mm-status-message>
      <slot></slot>
      ${(0, button_utils_1.renderActionButtons)({
            primaryAction: this.primaryAction,
            secondaryAction: this.secondaryAction,
            size: 'large',
        })}
    `;
    }
    renderAvatar() {
        if (!this.avatarIcon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-avatar size="80" variant="secondary" icon=${this.avatarIcon}></mm-avatar>
    `;
    }
};
Result.styles = [result_styles_1.resultStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-icon' })
], Result.prototype, "avatarIcon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Result.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Result.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Result.prototype, "role", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Result.prototype, "primaryAction", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Result.prototype, "secondaryAction", void 0);
Result = __decorate([
    (0, decorators_js_1.customElement)('mm-result')
], Result);
exports.Result = Result;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVzdWx0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUErQztBQUMvQyxxREFBMkQ7QUFLM0QsMEVBQTZFO0FBQzdFLDRFQUF1RTtBQUN2RSxzQ0FBbUM7QUFDbkMsNkNBQTBDO0FBQzFDLG1EQUFnRDtBQUNoRCw2REFBMEQ7QUFLbkQsSUFBTSxNQUFNLEdBQVosTUFBTSxNQUFPLFNBQVEsZ0JBQVU7SUFBL0I7O1FBR3VCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDWixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNELFNBQUksR0FBZSxRQUFRLENBQUE7SUF3QnhFLENBQUM7SUFwQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFJLENBQUMsWUFBWSxFQUFFO21DQUNRLElBQUksQ0FBQyxPQUFPLFlBQVksSUFBSSxDQUFDLFdBQVc7O1FBRW5FLElBQUEsa0NBQW1CLEVBQUM7WUFDcEIsYUFBYSxFQUFFLElBQUksQ0FBQyxhQUFhO1lBQ2pDLGVBQWUsRUFBRSxJQUFJLENBQUMsZUFBZTtZQUNyQyxJQUFJLEVBQUUsT0FBTztTQUNkLENBQUM7S0FDSCxDQUFBO0lBQ0gsQ0FBQztJQUVPLFlBQVk7UUFDbEIsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFcEMsT0FBTyxJQUFBLFVBQUksRUFBQTtzREFDdUMsSUFBSSxDQUFDLFVBQVU7S0FDaEUsQ0FBQTtJQUNILENBQUM7O0FBM0JNLGFBQU0sR0FBRyxDQUFDLDRCQUFZLENBQUMsQ0FBQTtBQUN3QjtJQUFyRCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxhQUFhLEVBQUUsQ0FBQzswQ0FBc0I7QUFDL0M7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFhO0FBQ1o7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUFpQjtBQUNEO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO29DQUE0QjtBQUN0QztJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7NkNBQTZCO0FBQzVCO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQzsrQ0FBK0I7QUFQbkQsTUFBTTtJQURsQixJQUFBLDZCQUFhLEVBQUMsV0FBVyxDQUFDO0dBQ2QsTUFBTSxDQTZCbEI7QUE3Qlksd0JBQU0ifQ==